import React, { useCallback, useEffect, useState } from 'react';
import dimens from 'resources/dimens';
import { useDispatch } from 'react-redux';
import { FadeLoading } from 'components/FadeLoading';
import {
  fetchEmbedUrl,
  setFetchError,
  setFilterShipName,
  setSelectedShipId,
  setShips,
  useQSReportEmbedUrl,
  useQSReportFetchError,
  useQSReportFetching,
  useQSReportFilteredShips,
  useQSReportSelectedShipId,
} from './qsReportSlice';
import { RootContainer } from 'components/RootContainer';
import { ApiErrorDialog } from 'components/ApiErrorDialog';
import { useCommonShips } from 'app/commonSlice';
import { useAppBarConfirmedReorderShips } from 'features/appBar/mainAppBarSlice';
import AppLogger from 'utils/AppLogger';
import { styled } from '@mui/material';
import { ShipDrawer } from './ShipDrawer';

const ContentsDiv = styled('div')({
  width: '100%',
  height: '100%',
});

// const ContentsDiv = styled('div')({
//   position: 'absolute',
//   top: 0,
//   left: dimens.event.eventPanel.closeWidth,
//   background: colors.subDrawer.background,
//   width: `calc(100% - ${dimens.event.eventPanel.closeWidth}px)`,
//   height: '100%',
//   overflowX: 'auto',
// });

interface QSReportFragmentProps {
  hidden: boolean;
}

export function QSReportFragment(props: QSReportFragmentProps): JSX.Element {
  AppLogger.debug('CALL: QSReportFragment');
  const { hidden } = props;
  const dispatch = useDispatch();
  const [shipDrawerOpen, setShipDrawerOpen] = useState(true);
  const reorderShips = useAppBarConfirmedReorderShips();
  const ships = useCommonShips();
  const filteredShips = useQSReportFilteredShips();
  const selectedShipId = useQSReportSelectedShipId();
  const fetching = useQSReportFetching();
  const fetchError = useQSReportFetchError();
  const embedUrl = useQSReportEmbedUrl();

  /**
   * 検索入力変更
   * @param event イベント
   */
  const handleSeachInputChange = (input: string) => {
    dispatch(setFilterShipName(input));
  };

  /**
   * 船舶ドロワー開閉状態変更
   * @param open 開閉状態
   */
  const handleShipDrawerChangeOpen = (open: boolean) => {
    setShipDrawerOpen(open);
  };

  /**
   * データ取得エラー
   */
  const handleFetchError = () => {
    dispatch(setFetchError(undefined));
  };

  const handleChangeShip = (shipId: string): void => {
    dispatch(setSelectedShipId(shipId));
  };

  const handleOk = () => {
    if (!selectedShipId) {
      return;
    }

    const selectedShip = (ships ?? []).find((ship) => ship.shipId === selectedShipId);
    selectedShip && dispatch(fetchEmbedUrl(selectedShip));
  };

  useEffect(() => {
    if (ships != null && ships.length > 0 && !hidden) {
      dispatch(setShips(ships));
    }
  }, [dispatch, ships, hidden]);

  return (
    <RootContainer hidden={hidden}>
      <ShipDrawer
        ships={filteredShips}
        open={shipDrawerOpen}
        onChangeOpen={handleShipDrawerChangeOpen}
        onSearchInputChange={handleSeachInputChange}
        onChangeShip={handleChangeShip}
        onOkClick={handleOk}
        selectedShipId={selectedShipId}
        scrollvbarMargin={dimens.shipState.realtimeAisScrollbar.margin}
      />
      <ContentsDiv
        sx={{
          left: 0,
          width: '100%',
          overflowY: 'hidden',
        }}
      >
        {embedUrl && (
          <iframe
            title="Dashboard"
            src={embedUrl}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
          />
        )}
      </ContentsDiv>
      <FadeLoading loading={fetching} />
      {fetchError != null && <ApiErrorDialog error={fetchError} onClose={handleFetchError} />}
    </RootContainer>
  );
}
